import { render, staticRenderFns } from "./Solar.vue?vue&type=template&id=2263d4f2&scoped=true&"
import script from "./Solar.vue?vue&type=script&lang=js&"
export * from "./Solar.vue?vue&type=script&lang=js&"
import style0 from "./Solar.vue?vue&type=style&index=0&id=2263d4f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2263d4f2",
  null
  
)

export default component.exports